import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { updateSEO, SEO_CONFIGS, DEFAULT_SEO, SEOConfig } from '../utils/seoUtils';

export const useSEO = (config?: Partial<SEOConfig>) => {
  const location = useLocation();

  useEffect(() => {
    // Determine which page we're on and apply appropriate SEO
    const pathname = location.pathname;
    
    let seoConfig: SEOConfig;
    
    if (config) {
      // Use provided config
      seoConfig = { ...DEFAULT_SEO, ...config };
    } else {
      // Auto-detect based on route
      if (pathname === '/' || pathname === '/login') {
        seoConfig = SEO_CONFIGS.login;
      } else if (pathname.includes('/register')) {
        seoConfig = SEO_CONFIGS.register;
      } else if (pathname.includes('/module/flashcards') || pathname.includes('/flashcards')) {
        seoConfig = SEO_CONFIGS.flashcards;
      } else if (pathname.includes('/module/exams') || pathname.includes('/exams')) {
        seoConfig = SEO_CONFIGS.exams;
      } else if (pathname.includes('/module/writing') || pathname.includes('/writing')) {
        seoConfig = SEO_CONFIGS.writing;
      } else if (pathname.includes('/module/notes') || pathname.includes('/notes')) {
        seoConfig = SEO_CONFIGS.notes;
      } else if (pathname.includes('/module/understanding') || pathname.includes('/understanding')) {
        seoConfig = SEO_CONFIGS.understanding;
      } else if (pathname.includes('/module/listening') || pathname.includes('/listening')) {
        seoConfig = SEO_CONFIGS.listening;
      } else if (pathname.includes('/profile')) {
        seoConfig = SEO_CONFIGS.profile;
      } else {
        seoConfig = SEO_CONFIGS.home;
      }
    }

    // Update SEO with the determined configuration
    updateSEO(seoConfig);
  }, [location.pathname, config]);
};

// Hook for specific page SEO
export const usePageSEO = (pageType: keyof typeof SEO_CONFIGS, customConfig?: Partial<SEOConfig>) => {
  useEffect(() => {
    const baseConfig = SEO_CONFIGS[pageType];
    const seoConfig = customConfig ? { ...baseConfig, ...customConfig } : baseConfig;
    updateSEO(seoConfig);
  }, [pageType, customConfig]);
};

// Hook for dynamic content SEO (e.g., specific flashcard sets, exams)
export const useDynamicSEO = (title: string, description?: string, keywords?: string) => {
  useEffect(() => {
    const seoConfig: SEOConfig = {
      title,
      description: description || DEFAULT_SEO.description,
      keywords: keywords || DEFAULT_SEO.keywords,
      image: DEFAULT_SEO.image,
      url: DEFAULT_SEO.url
    };
    updateSEO(seoConfig);
  }, [title, description, keywords]);
}; 